import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { authLog } from 'src/app/auth/auth.handler';
import { Auth } from 'src/app/core/common/auth';
import { toRouterPath } from 'src/app/core/helpers/utils';

export const ReturnUrlGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  authLog(`auth.flow::=>return.url.guard: canActivate`, { currentUrl: router.url, nextUrl: state.url });
  return inject(Auth)
    .getReturnUrl()
    .pipe(
      map(returnUrl => {
        authLog(`auth.flow::=>return.url.guard:`, { returnUrl, href: window.location.href, routerUrl: router.url });
        if (returnUrl) {
          return router.parseUrl(toRouterPath(returnUrl));
        }
        // no return url, proceed to target route, e.g: '/' => splash
        return true;
      })
    );
};
